import { FC, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAdmin, useAuthenticationService } from '../authentication-service';
import { useAdminLocationStore } from '@/services/location/useAdminLocationStore';
import { useLocationService } from '@/services/location/LocationService';

/*
 * Certain pages are very location specific.
 * For staff members with a single location, this is straightforward.
 * If they have multiple locations, we need to send them back to the homepage to choose a location before they
 * can view the page.
 */
export const RequireActingLocation: FC = () => {
  const actingLocation = useAdminLocationStore(s => s.actingLocation);
  const hasActingLocation = actingLocation !== undefined;

  const [role] = useAuthenticationService(state => [state.role]);
  const requiresActingLocation = isAdmin(role);

  const selectedLocation = useLocationService(s => s.selectedLocation);

  useEffect(() => {
    const updateStoredTime = () => {
      localStorage.setItem('admin-local-storage-storedAt', new Date().toISOString());
    };

    if (hasActingLocation) {
      const intervalId = setInterval(updateStoredTime, 10000);
      return () => clearInterval(intervalId);
    }
  }, [hasActingLocation]);

  if (requiresActingLocation && !hasActingLocation) {
    return <Navigate to={'/'} />;
  }

  if (!selectedLocation) {
    throw Error('Location must be selected.');
  }

  return <Outlet />;
};
